"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var employee_level_1 = require("./employeelevel/employee-level");
var Search_1 = require("./Common/Search");
var orgSetup_1 = require("./orgSetup");
require("./org.scss");
var Org = (function (_super) {
    __extends(Org, _super);
    function Org(props) {
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.initialize();
        _this.buildEmployeeTree();
        _this.handleOnEmployeeClick = _this.handleOnEmployeeClick.bind(_this);
        _this.handleViewEmployee = _this.handleViewEmployee.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.handleSearchResultSelected = _this.handleSearchResultSelected.bind(_this);
        _this.handleGetSelectedValue = _this.handleGetSelectedValue.bind(_this);
        _this.handleUpButtonOnClick = _this.handleUpButtonOnClick.bind(_this);
        return _this;
    }
    Object.defineProperty(Org.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a = this.props, onClose = _a.onClose, closeLinkText = _a.closeLinkText;
            var employeeStore = this.store.employeeStore;
            var hiddenClass = this.isTopLevel() ? ' hide-btn' : '';
            return (React.createElement("div", { className: "org-level", hidden: this.props.isHidden },
                React.createElement("div", { className: "nav-bar" },
                    React.createElement("div", { className: "org-nav-left" },
                        React.createElement("span", null,
                            React.createElement("a", { onClick: onClose },
                                React.createElement("i", { className: "icon-reply" }),
                                React.createElement("span", null, closeLinkText)))),
                    React.createElement("div", { className: "org-nav-right" },
                        React.createElement(Search_1.default, { placeholder: "Search", search: this.handleSearch, resultLimit: employeeStore.defaultSearchResultLimit, onSuggestionSelected: this.handleSearchResultSelected, getSelectedValue: this.handleGetSelectedValue, getRenderedSuggestionText: employeeStore.getSearchSuggestionText }))),
                React.createElement("div", { className: "search-column" },
                    React.createElement("button", { disabled: employeeStore.currentlyBuildingTree, className: "up-level-btn no-btn-style" + hiddenClass, onClick: this.handleUpButtonOnClick },
                        React.createElement("i", { className: "icon-left" }),
                        " Up 1 Level")),
                React.createElement("div", { className: "directs-column" },
                    React.createElement("h3", null,
                        React.createElement("span", { className: "direct-of" }, "Directs of"),
                        React.createElement("br", null),
                        this.renderFocusedEmployeeDisplayName())),
                React.createElement("div", { className: "employee-columns" },
                    this.renderEmployeeLevels(),
                    this.renderHasNoTeamNotification())));
        }
    });
    Object.defineProperty(Org.prototype, "handleGetSelectedValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employee) {
            return employee.displayName || '';
        }
    });
    Object.defineProperty(Org.prototype, "handleSearch", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (searchText, resultLimit) {
            return __awaiter(this, void 0, void 0, function () {
                var employeeStore;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            employeeStore = this.store.employeeStore;
                            return [4, employeeStore.getSuggestedEmployees(searchText, resultLimit)];
                        case 1: return [2, (_a.sent()) || []];
                    }
                });
            });
        }
    });
    Object.defineProperty(Org.prototype, "buildEmployeeTree", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var employeeStore;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            employeeStore = this.store.employeeStore;
                            return [4, employeeStore.getEmployee(this.props.employeeSourceId)];
                        case 1:
                            _a.sent();
                            employeeStore.focusOnEmployee(this.props.employeeSourceId);
                            return [4, Promise.all([
                                    employeeStore.ensureEmployeePeersAndManager(),
                                    employeeStore.ensureEmployeeTree(this.props.displayedLevelCount)
                                ])];
                        case 2:
                            _a.sent();
                            employeeStore.setInitialLevel();
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(Org.prototype, "renderFocusedEmployeeDisplayName", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var employeeStore = this.store.employeeStore;
            if (!employeeStore.focusedEmployee) {
                return null;
            }
            return (React.createElement("span", null, employeeStore.focusedEmployee.displayName));
        }
    });
    Object.defineProperty(Org.prototype, "renderHasNoTeamNotification", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var employeeStore = this.store.employeeStore;
            var levels = employeeStore.getEmployeesForEachLevel(this.props.displayedLevelCount);
            if (!levels) {
                return null;
            }
            if (!employeeStore.focusedEmployee || employeeStore.focusedEmployee.isIndividualContributor === false) {
                return null;
            }
            return (React.createElement("div", null,
                React.createElement("span", null, "You have no team.")));
        }
    });
    Object.defineProperty(Org.prototype, "renderEmployeeLevels", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var employeeStore = this.store.employeeStore;
            var renderedEmployeeLevels = [];
            var levels = employeeStore.getEmployeesForEachLevel(this.props.displayedLevelCount);
            if (!levels) {
                return null;
            }
            var lastDisplayedLevel = employeeStore.initialLevel + this.props.displayedLevelCount;
            levels.forEach(function (employees, level) {
                if (employees.length === 0) {
                    return;
                }
                renderedEmployeeLevels.push((React.createElement(employee_level_1.default, { key: level, store: _this.store, onEmployeeClick: _this.handleOnEmployeeClick, onViewEmployee: _this.handleViewEmployee, employees: employees, maxRowsPerLevel: _this.props.maxRowsPerLevel, className: employeeStore.getLevelClasses(level, lastDisplayedLevel), employeeSortFormat: _this.props.employeeSortFormat })));
            });
            return renderedEmployeeLevels;
        }
    });
    Object.defineProperty(Org.prototype, "handleViewEmployee", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employee) {
            if (employee.employeeSourceId) {
                this.props.onViewEmployee(employee.employeeSourceId);
            }
        }
    });
    Object.defineProperty(Org.prototype, "isTopLevel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var employeeStore = this.store.employeeStore;
            if (employeeStore.focusedEmployee) {
                return employeeStore.focusedEmployee.managerSourceId == null;
            }
            return true;
        }
    });
    Object.defineProperty(Org.prototype, "handleUpButtonOnClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var employeeStore;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            employeeStore = this.store.employeeStore;
                            if (!employeeStore.focusedEmployee || !employeeStore.focusedEmployee.managerSourceId) {
                                return [2];
                            }
                            return [4, employeeStore.getEmployee(employeeStore.focusedEmployee.managerSourceId)];
                        case 1:
                            _a.sent();
                            employeeStore.focusOnEmployee(employeeStore.focusedEmployee.managerSourceId);
                            return [4, Promise.all([
                                    employeeStore.ensureEmployeePeersAndManager(),
                                    employeeStore.ensureEmployeeTree(this.props.displayedLevelCount)
                                ])];
                        case 2:
                            _a.sent();
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(Org.prototype, "handleOnEmployeeClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employee) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!employee.employeeSourceId ||
                                employee.isIndividualContributor ||
                                this.store.employeeStore.isFirstLevelEmployee(employee)) {
                                return [2];
                            }
                            return [4, this.store.employeeStore.getEmployee(employee.employeeSourceId)];
                        case 1:
                            _a.sent();
                            this.store.employeeStore.focusOnEmployee(employee.employeeSourceId);
                            return [4, Promise.all([
                                    this.store.employeeStore.ensureEmployeePeersAndManager(),
                                    this.store.employeeStore.ensureEmployeeTree(this.props.displayedLevelCount)
                                ])];
                        case 2:
                            _a.sent();
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(Org.prototype, "handleSearchResultSelected", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employee) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!employee.employeeSourceId) {
                                return [2];
                            }
                            return [4, this.store.employeeStore.getEmployee(employee.employeeSourceId)];
                        case 1:
                            _a.sent();
                            this.store.employeeStore.focusOnEmployee(employee.employeeSourceId);
                            return [4, Promise.all([
                                    this.store.employeeStore.ensureEmployeePeersAndManager(),
                                    this.store.employeeStore.ensureEmployeeTree(this.props.displayedLevelCount)
                                ])];
                        case 2:
                            _a.sent();
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(Org.prototype, "initialize", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a, masterAccountId, accessToken, baseUrl;
                return __generator(this, function (_b) {
                    _a = this.props, masterAccountId = _a.masterAccountId, accessToken = _a.accessToken, baseUrl = _a.baseUrl;
                    this.store = orgSetup_1.OrgSetup.createStore(masterAccountId, accessToken, baseUrl);
                    return [2];
                });
            });
        }
    });
    return Org;
}(React.Component));
exports.Org = Org;
exports.default = mobx_react_1.inject('store')(mobx_react_1.observer(Org));
